// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import AppComp from '../../components/KeldanAppPage/KeldanAppPage';

const About: React.FC = () => {
    return (
        <Entrypoint>
            <AppComp />
        </Entrypoint>
    );
}

export default About;